import React from "react";

import { useFormContext } from "react-hook-form";

import { SelectProps } from "@mui/material";

import { VacancyReason } from "@covertree/types";
import { FormSelectField } from "@covertree/ui";
import { EffectiveDateExposureAndLapseForm } from "../validatorsAndTypes/effectiveDateExposureAndLapseForm";

type Props = SelectProps & {
  name: string; // @TODO investigate why "Path" from "react-hook-form" type is not working
  label: React.ReactNode;
  placeholder?: string;
};

const options = Object.entries(VacancyReason).map(([value, label]) => ({
  value,
  label,
}));

export function FormVacancyReasonSelect({
  name,
  label,
  placeholder = "Select ...",
}: Props) {
  const { control } = useFormContext<EffectiveDateExposureAndLapseForm>();

  return (
    <FormSelectField
      id="reasons-for-vacancy"
      dataTestId="why-is-your-home-vacant"
      name={name}
      control={control}
      options={options}
      label={label}
      placeholder={placeholder}
    />
  );
}
